import { Observable, observe, Scope } from 'src/3rds/cube'

// :: Types

/** Conferência de um CNPJ: a matriz que vai ser gravada e o grupo manual atual dela. */
export type Empresa = {
    cnpjInformado: string
    cnpjMatriz: string
    razaoSocial?: string
    ativa: boolean
    grupoAtual?: number
}

export type Negocio = {
    dealId: string
    fase: string
    parceiro?: string
}

export type OrigemNoGrupo = 'consultada' | 'manual' | 'socios'

export type EmpresaDoGrupo = {
    cnpj: string
    razaoSocial?: string
    ativa: boolean
    origem: OrigemNoGrupo
    negocios: Negocio[]
}

export type TipoEvento = 'criado' | 'incluida' | 'retirada' | 'unido'

/** Um passo do histórico de um grupo manual: quem fez, o quê, quando e por quê. */
export type Evento = {
    id: string
    tipo: TipoEvento
    cnpj?: string
    razaoSocial?: string
    cnpjRelacionado?: string
    razaoSocialRelacionada?: string
    grupoIdOrigem?: number
    usuario: string
    motivo: string
    quando: string
}

export type Situacao = {
    empresa: Empresa
    grupoManual?: { grupoId: number; qtdeEmpresas: number; empresaPrincipal?: string }
    grupoLia: EmpresaDoGrupo[]
    historico: Evento[]
}

export type GrupoResumo = {
    grupoId: number
    empresaPrincipal?: string
    cnpjPrincipal?: string
    qtdeEmpresas: number
    negociosEmAndamento: number
    ultimaAlteracao?: Evento
}

export type OrdemGrupos = 'alterado' | 'grupo' | 'empresas' | 'negocios'

/** Sugestão da busca por nome (empresas que a AG tem no HubSpot). */
export type Sugestao = {
    cnpj: string
    razaoSocial?: string
    grupoAtual?: number
}

export type NegocioDaEmpresa = Negocio & { cnpj: string; razaoSocial?: string }

export type Impacto = {
    empresasNovas: number
    negocios: NegocioDaEmpresa[]
}

/** O que a ligação faria, calculado pelo servidor sem gravar nada. */
export type Simulacao = {
    modo: 'criar' | 'incluir' | 'unir'
    paraEmpresa: Impacto
    paraOutra: Impacto
    unir?: { grupoFica: number; grupoSai: number; qtdeFica: number; qtdeSai: number }
}

/** O motivo fica no histórico do grupo; o servidor exige o mesmo mínimo. */
export const MOTIVO_MINIMO = 10

export const GRUPOS_POR_PAGINA = 25

// :: Scopes

@Observable
export class GrupoManualScope extends Scope {
    @observe() aba: 'empresa' | 'grupos' = 'empresa'

    // Aba "por empresa"
    @observe() busca = ''
    @observe() erroBusca?: string
    @observe() sugestoes: Sugestao[] = []
    @observe() situacao?: Situacao
    @observe() carregandoSituacao = false

    // Aba "todos os grupos"
    @observe() filtro = ''
    @observe() ordem: OrdemGrupos = 'alterado'
    @observe() pagina = 0
    @observe() total = 0
    @observe() grupos: GrupoResumo[] = []
    @observe() carregandoLista = false

    // Diálogo "Ligar a outra empresa"
    @observe() ligarAberto = false
    @observe() cnpjLigar = ''
    @observe() conferenciaLigar?: Empresa
    @observe() erroLigar?: string
    @observe() motivoLigar = ''
    @observe() sugestoesLigar: Sugestao[] = []
    @observe() simulacao?: Simulacao
    @observe() simulando = false

    // Diálogo "Tirar do grupo manual"
    @observe() retirarAberto = false
    @observe() motivoRetirar = ''

    @observe() conferindo = false
    @observe() salvando = false

    onAbaChange = Scope.ASYNC_ACTION_ONE<'empresa' | 'grupos'>()

    onBuscaChange = Scope.ASYNC_ACTION_STRING
    onEscolherEmpresa = Scope.ASYNC_ACTION_STRING

    onFiltroChange = Scope.ASYNC_ACTION_STRING
    onOrdemChange = Scope.ASYNC_ACTION_ONE<OrdemGrupos>()
    onPaginaChange = Scope.ASYNC_ACTION_ONE<number>()
    onAbrirEmpresa = Scope.ASYNC_ACTION_STRING

    onAbrirLigar = Scope.ASYNC_ACTION
    onFecharLigar = Scope.ASYNC_ACTION
    onCnpjLigarChange = Scope.ASYNC_ACTION_STRING
    onEscolherOutra = Scope.ASYNC_ACTION_STRING
    onConfirmarLigar = Scope.ASYNC_ACTION
    onMotivoLigarChange = Scope.ASYNC_ACTION_STRING

    onAbrirRetirar = Scope.ASYNC_ACTION
    onFecharRetirar = Scope.ASYNC_ACTION
    onConfirmarRetirar = Scope.ASYNC_ACTION
    onMotivoRetirarChange = Scope.ASYNC_ACTION_STRING
}
